import { ZEC, ZCASH_CONVERSION_NUM, ZATOSHI_CONVERSION_NUM } from "../constants";

export const formatAmountAsPerTheCoinUnit = (coinUnit, amount) => {
    if (coinUnit == ZEC) {
        return parseFloat(amount).toFixed(ZCASH_CONVERSION_NUM);
    } else {
        return (amount * ZATOSHI_CONVERSION_NUM).toLocaleString();
    }
};

export const calcAmountNumberAsPerCoinUnit = (coinUnit, amount) => {
    if (coinUnit == ZEC) {
        return Number(amount.toFixed(ZCASH_CONVERSION_NUM));
    } else {
        return Number(amount * ZATOSHI_CONVERSION_NUM);
    }
};
